import {
    ADD_DRIVER_CALL_REQUEST,
    ADD_DRIVER_CALL_SUCCESS,
    ADD_DRIVER_CALL_FAILURE,
    GET_DRIVER_CALLS_REQUEST,
    GET_DRIVER_CALLS_SUCCESS,
    GET_DRIVER_CALLS_FAILURE,
    CLEAR_DRIVER_CALL_STATUS,
} from "../../redux/actions/driverCallsAction";

export interface DriverCall {
    id: number;
    drcallid?: number;
    cabId: string;
    reason: string;
    remarks: string;
    type: string;
    updateBy: string;
    date: string;
}

interface DriverCallsState {
    data: DriverCall[];
    total: number;
    loading: boolean;
    error: string | null;
    adding: boolean;
    addError: string | null;
    addSuccess: string | null;
}

const initialState: DriverCallsState = {
    data: [],
    total: 0,
    loading: false,
    error: null,
    adding: false,
    addError: null,
    addSuccess: null,
};

const driverCallsReducer = (state = initialState, action: any): DriverCallsState => {
    switch (action.type) {
        case GET_DRIVER_CALLS_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_DRIVER_CALLS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                total: action.payload.total,
                error: null,
            };
        case GET_DRIVER_CALLS_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case ADD_DRIVER_CALL_REQUEST:
            return { ...state, adding: true, addError: null, addSuccess: null };
        case ADD_DRIVER_CALL_SUCCESS:
            return { ...state, adding: false, addError: null, addSuccess: action.payload };
        case ADD_DRIVER_CALL_FAILURE:
            return { ...state, adding: false, addError: action.payload, addSuccess: null };
        case CLEAR_DRIVER_CALL_STATUS:
            return { ...state, addError: null, addSuccess: null };

        default:
            return state;
    }
};

export default driverCallsReducer;